import React, { useState } from 'react';

import Collapse from 'react-bootstrap/Collapse';
import CustomTd from '../shared/table/CustomTd';
import EditDeleteButton from '../shared/buttons/EditDeleteButton';
import formatter from '../../utilities/formatter';
import postData from '../../utilities/postData';
import PropTypes from 'prop-types';
import useBreakpoints from '../../utilities/useBreakpoints';

const SalesAppointmentItem = (props) => {
    const { item } = props;
    const deleteUrl = '/api/calendar/delete/sales/' + item.id;

    const [expanded, setExpanded] = useState(false);
    const { isBreakpoint } = useBreakpoints();

    function deleteItem() {
        postData(deleteUrl, null, () => {
            props.fetchData();
            window.dispatchEvent(new Event('updateChangeLog'));
        });
    }

    const areas = (
        <div className="d-flex flex-column">
            {item.areasInterestedIn.map((area, index) =>
                <span key={index}>{area.areaTypeName}</span>)}
        </div>);

    const expandingNotes = (
        <div>
            <div className="action-button" onClick={() => setExpanded(!expanded)}>
                {expanded
                    ? <img src="/images/expander-minus.svg" />
                    : <img src="/images/expander-plus.svg" />
                }
                <span className="ml-1 d-inline-block text-truncate">
                    <strong>Appt Notes</strong>
                    (Customer will see this note)
                </span>
            </div>
            <Collapse in={expanded}>
                <div style={{ paddingLeft: '35px', whiteSpace: 'pre-wrap' }}>
                    {item.note}
                </div>
            </Collapse>
        </div>
    );

    return (
        <tr>
            <td style={{ padding: '0', border: 'none' }}
                colSpan={isBreakpoint('md') ? 5 : isBreakpoint('sm') ? 4 : 3}>
                <table style={{ width: '100%', border: 'none' }}>
                    <tbody>
                        <tr>
                            <CustomTd content={item.designerName} />
                            <CustomTd width={isBreakpoint('md') ? '170px' : ''} style={{ textWrap: 'balance' }} content={formatter.dateTimePretty(item.appointmentDate)} />
                            <CustomTd width="75px" style={{ textAlign: 'center' }} content={item.areaCount} hide="sm" />
                            <CustomTd content={areas} hide="md" />
                            <CustomTd width="80px" className="button-cell">
                                <EditDeleteButton
                                    deleteItem={deleteItem}
                                    viewItem={props.editItem}
                                    editItem={props.editItem}
                                    showText={false}
                                    acl={item.acl}
                                />
                            </CustomTd>
                        </tr>
                        <tr>
                            <CustomTd className="border-0" colSpan={3}>
                                {expandingNotes}
                            </CustomTd>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>
    );
}

SalesAppointmentItem.propTypes = {
    deleteUrl: PropTypes.string,
    editItem: PropTypes.func,
    fetchData: PropTypes.func
};

export default SalesAppointmentItem;